// extracted by mini-css-extract-plugin
export var leftSpan = "SearchResultsSideNav-module--left-span--3921e";
export var mobileLabel = "SearchResultsSideNav-module--mobile-label--c2a3b";
export var rightSpan = "SearchResultsSideNav-module--right-span--f573c";
export var singleCheckboxContainer = "SearchResultsSideNav-module--single-checkbox-container--d753d";
export var topicHeading = "SearchResultsSideNav-module--topic-heading--9e334";